import React from 'react';

interface IcoFacebookProps {
    size?: number;
}

export const IcoFacebook: React.FC<IcoFacebookProps> = ({ size = 22 }) => {
    const wrapperStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div style={wrapperStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
                <g fill="none" opacity=".6">
                    <circle cx="11.92" cy="11.92" r="10" fill="#F1F1F1" />
                    <path
                        fill="#605F68"
                        d="M10.425 10.192v1.749H7.951v2.629h2.474v7.226c.489.074.986.124 1.495.124.46 0 .91-.042 1.354-.102V14.57h2.588l.406-2.629h-2.995v-1.437c0-1.092.357-2.061 1.379-2.061h1.642V6.149c-.289-.039-.898-.124-2.051-.124-2.407 0-3.818 1.271-3.818 4.167z"
                    />
                </g>
            </svg>
        </div>
    );
};
